/* Tabs — horizontal tab bar with optional pill variant.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';
import { Icon } from './Icon';
import type { IconName } from './Icon';

export interface TabItem {
  id: string;
  label: React.ReactNode;
  icon?: IconName;
  count?: number;
}

export interface TabsProps {
  tabs: TabItem[];
  active: string;
  onChange: (id: string) => void;
  pill?: boolean;
}

export function Tabs({ tabs, active, onChange, pill }: TabsProps) {
  return (
    <div className={pill ? 'tabs-pill' : 'tabs'}>
      {tabs.map((t) => (
        <button
          key={t.id}
          className={'tab' + (active === t.id ? ' active' : '')}
          onClick={() => onChange(t.id)}
        >
          {t.icon && <Icon name={t.icon} size={15} />}
          {t.label}
          {t.count != null && <span className="tab-count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
